var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 2.27393H10.5762V1.83447C10.5762 1.10753 9.98476 0.516113 9.25781 0.516113H5.74219C5.01524 0.516113 4.42383 1.10753 4.42383 1.83447V2.27393H2.22656C1.49962 2.27393 0.908203 2.86534 0.908203 3.59229C0.908203 4.17611 1.28979 4.6722 1.81655 4.84505L2.60039 14.3072C2.65685 14.9851 3.23394 15.5161 3.91418 15.5161H11.0858C11.7661 15.5161 12.3432 14.9851 12.3997 14.307L13.1834 4.84502C13.7102 4.6722 14.0918 4.17611 14.0918 3.59229C14.0918 2.86534 13.5004 2.27393 12.7734 2.27393ZM5.30273 1.83447C5.30273 1.59216 5.49987 1.39502 5.74219 1.39502H9.25781C9.50013 1.39502 9.69727 1.59216 9.69727 1.83447V2.27393H5.30273V1.83447ZM11.5238 14.2343C11.5049 14.4602 11.3126 14.6372 11.0858 14.6372H3.91418C3.68745 14.6372 3.49509 14.4602 3.47631 14.2345L2.70393 4.91064H12.2961L11.5238 14.2343ZM12.7734 4.03174H2.22656C1.98425 4.03174 1.78711 3.8346 1.78711 3.59229C1.78711 3.34997 1.98425 3.15283 2.22656 3.15283H12.7734C13.0158 3.15283 13.2129 3.34997 13.2129 3.59229C13.2129 3.8346 13.0158 4.03174 12.7734 4.03174Z",
    fill: "#FB462E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74137 13.2917L5.30192 6.20183C5.28689 5.95958 5.07721 5.77533 4.83613 5.79042C4.59387 5.80544 4.40968 6.01398 4.42468 6.25621L4.86414 13.3461C4.87858 13.5791 5.07206 13.7583 5.30233 13.7583C5.55683 13.7583 5.75699 13.544 5.74137 13.2917Z",
    fill: "#FB462E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.78955C7.2573 5.78955 7.06055 5.98631 7.06055 6.229V13.3188C7.06055 13.5615 7.2573 13.7583 7.5 13.7583C7.7427 13.7583 7.93945 13.5615 7.93945 13.3188V6.229C7.93945 5.98631 7.7427 5.78955 7.5 5.78955Z",
    fill: "#FB462E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1639 5.79041C9.92221 5.77538 9.71312 5.95957 9.69812 6.20182L9.25866 13.2917C9.24369 13.5339 9.42788 13.7424 9.67011 13.7575C9.91248 13.7725 10.1209 13.5882 10.1359 13.346L10.5754 6.2562C10.5904 6.01394 10.4062 5.80541 10.1639 5.79041Z",
    fill: "#FB462E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.516113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/Clear.609dfc208c52cc29ca182df8246f9ef5.svg";
export { ForwardRef as ReactComponent };